import { apiRequest } from './client.ts';

export interface LeagueSummary {
  id: string;
  name: string;
  invite_code: string;
  competition_id: string;
  season_id: string;
  created_by_user_id: string | null;
  created_at: string;
  competition_name: string;
  competition_code: string;
  season_label: string;
  member_count: number;
  joined_at: string;
  role: 'owner' | 'member';
}

export interface Member {
  user_id: string;
  username: string;
  role: 'owner' | 'member';
  joined_at: string;
}

export interface Season {
  id: number;
  label: string;
  start_year: number;
  is_current: boolean;
}

export interface Competition {
  id: number;
  code: string;
  name: string;
  country_code: string;
  seasons: Season[];
}

export function listMyLeagues(): Promise<{ leagues: LeagueSummary[] }> {
  return apiRequest('/leagues');
}

export function getLeagueDetail(
  leagueId: string,
): Promise<{ league: LeagueSummary; members: Member[] }> {
  return apiRequest(`/leagues/${leagueId}`);
}

export function listCompetitions(): Promise<{ competitions: Competition[] }> {
  return apiRequest('/competitions');
}

export function createLeague(input: {
  name: string;
  competition_id: number;
  season_id: number;
}): Promise<{ league: LeagueSummary }> {
  return apiRequest('/leagues', { method: 'POST', body: input });
}

export function joinLeague(inviteCode: string): Promise<{
  league: LeagueSummary;
  membership: { joined_at: string; role: string };
  already_member: boolean;
}> {
  return apiRequest('/leagues/join', { method: 'POST', body: { invite_code: inviteCode } });
}

/**
 * Baja de la liga. Devuelve a quién ha pasado el rol de administrador, si es que el que
 * se va lo era y quedaba alguien.
 */
export function leaveLeague(leagueId: string): Promise<{ new_owner_user_id: string | null }> {
  return apiRequest(`/leagues/${leagueId}/membership`, { method: 'DELETE' });
}
